module.exports = __webpack_public_path__ + "static/media/computer-internet-woman.8dfd92aa.svg";